import { render, staticRenderFns } from "./Asistencial.vue?vue&type=template&id=b23dbc4a"
import script from "./Asistencial.vue?vue&type=script&lang=js"
export * from "./Asistencial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports